
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/sitemap",
      function () {
        return require("private-next-pages/nl/sitemap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/sitemap"])
      });
    }
  